import { Injectable } from "@angular/core";
import { UserControllerService, UsersFilter } from "@api-swagger-client/index";

@Injectable({
    providedIn: 'root'
  })
export class UserService {
    constructor(private userControllerService: UserControllerService,
    ) { }
  
          getCurrentUser = () => {
              const filters: any | UsersFilter = JSON.stringify({
                  where: {},
                  include: [
                      {
                          relation: 'company',
                      },
                      {
                          relation: 'jobPosition',
                      },
                      {
                          relation: 'department',
                      },
                      {
                          relation: 'jobCategory',
                      },
                  ],
              });
      
          return this.userControllerService.userControllerGetCurrentUserToShow(filters);
      }
}
